const TRACK_EVENT = 'Adjust.trackEvent';

export default {
  TRACK_EVENT,
};
